export default {
    productLoading: state => state.productLoading,
    productsListLoading: state => state.productsListLoading,
    productsList: state => state.productsList
}